<div class="animated fadeIn">
  <app-configurations-block [clientMode]="true" [collapsible]="false" />
</div>
